<div [formGroup]="innerForm" class="flex flex-row gap-2 w-full items-start transition-all duration-200 bg-transparent">

    <div class="flex-1 w-4/12 relative">
        <!-- <label class="form-label">Book of Bible</label> -->
        <input formControlName="book" type="text" placeholder="Book (e.g. Psalms)" (input)="onBookInput()"
            (keydown)="handleBookKeyDown($event)" (blur)="hideDropdown()"
            class="w-full px-3 py-2 rounded border-gray-300 focus:ring-0 text-sm bg-transparent outline-none">

        @if (showDropdown && filteredBooks.length > 0) {
        <ul
            class="absolute z-50 left-0 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-xl max-h-60 overflow-y-auto">
            @for (book of filteredBooks; track book; let i = $index) {
            <li (mousedown)="selectBook(book)" [class.bg-blue-100]="i === activeIndex"
                [class.text-blue-900]="i === activeIndex"
                class="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 text-gray-900 transition-colors">
                {{ book }}
            </li>
            }
        </ul>
        }
    </div>

    <div class="flex-1 max-w-24 w-3/12">
        <!-- <label class="form-label">Chapter</label> -->
        <input formControlName="chapter" type="number" placeholder="Chapter"
            class="w-full px-2 py-2 rounded border-gray-300 text-sm bg-transparent text-start [appearance:textfield]">
    </div>

    <div class="flex-1 w-5/12">
        <div class="flex flex-col w-full">
            <!-- <label class="form-label">Verse Range</label> -->
            <div class="flex flex-row w-full">
                <input formControlName="fromVerse" type="number" placeholder="From Verse"
                    class="w-full px-2 py-2 rounded border-gray-300 text-sm bg-transparent text-center [appearance:textfield]">
                <span class="px-2 py-2 text-sm">-</span>
                <input formControlName="toVerse" type="number" placeholder="To Verse"
                    class="w-full px-2 py-2 rounded border-gray-300 text-sm bg-transparent text-center [appearance:textfield]"
                    [class.border-red-400]="innerForm.get('toVerse')?.invalid && innerForm.get('toVerse')?.touched">
            </div>
        </div>
    </div>